import { w as o } from "./components/BaseIcon/icons/1x.svg_raw-hBr8FzD0.js";
import { w as r } from "./components/BaseIcon/icons/2x.svg_raw-C-1rXgzv.js";
import { w as a } from "./components/BaseIcon/icons/4x.svg_raw-CSKdScYv.js";
import { w as t } from "./components/BaseIcon/icons/activity.svg_raw-B7_n6U9x.js";
import { w as m } from "./components/BaseIcon/icons/add-comment.svg_raw-CIe5O0L3.js";
import { w as i } from "./components/BaseIcon/icons/add-comments-round-alt.svg_raw-CzdWpmVN.js";
import { w } from "./components/BaseIcon/icons/add-new.svg_raw-fE5Siblo.js";
import { w as e } from "./components/BaseIcon/icons/add-panel.svg_raw-BgXkltAE.js";
import { w as s } from "./components/BaseIcon/icons/add-reaction.svg_raw-CPh8-910.js";
import { w as _ } from "./components/BaseIcon/icons/add-to-report.svg_raw-EUJug_cT.js";
import { w as p } from "./components/BaseIcon/icons/admin-shield-safe.svg_raw-CQz-plr3.js";
import { w as b } from "./components/BaseIcon/icons/agent-stop.svg_raw-CvIbF9fm.js";
import { w as l } from "./components/BaseIcon/icons/alias-alt.svg_raw-BM2lUsxv.js";
import { w as f } from "./components/BaseIcon/icons/alias-protected.svg_raw-OhXojyCo.js";
import { w as n } from "./components/BaseIcon/icons/amazon-sagemaker.svg_raw-Cv8qe4L8.js";
import { w as c } from "./components/BaseIcon/icons/apps.svg_raw-CSI3BkoY.js";
import { w as d } from "./components/BaseIcon/icons/arrow-up-from-line.svg_raw-Du4fZWTb.js";
import { w as u } from "./components/BaseIcon/icons/artifact-type.svg_raw-1kcS09pk.js";
import { w as h } from "./components/BaseIcon/icons/artifact-type-alt.svg_raw-K1c0UPV2.js";
import { w as g } from "./components/BaseIcon/icons/attachment.svg_raw-Cb3uwyZx.js";
import { w as k } from "./components/BaseIcon/icons/audio-volume.svg_raw-BDO2KplR.js";
import { w as y } from "./components/BaseIcon/icons/automation-robot-arm.svg_raw-qTsE74xp.js";
import { w as v } from "./components/BaseIcon/icons/baby.svg_raw-CMv2k6V8.js";
import { w as x } from "./components/BaseIcon/icons/back.svg_raw-Bu455cMY.js";
import { w as z } from "./components/BaseIcon/icons/baseline-alt.svg_raw-CDlYv7G0.js";
import { w as j } from "./components/BaseIcon/icons/bell-notifications.svg_raw-5Fe0oZub.js";
import { w as q } from "./components/BaseIcon/icons/benchmark-square.svg_raw-VJKAejnF.js";
import { w as I } from "./components/BaseIcon/icons/bike.svg_raw-ppPa1QtF.js";
import { w as A } from "./components/BaseIcon/icons/blog-alt.svg_raw-BeYG_HkU.js";
import { w as C } from "./components/BaseIcon/icons/blog-report.svg_raw-DoFenGfE.js";
import { w as M } from "./components/BaseIcon/icons/bokeh.svg_raw-Dqmv7jYl.js";
import { w as N } from "./components/BaseIcon/icons/bold.svg_raw-DT2tXb3f.js";
import { w as O } from "./components/BaseIcon/icons/book-dictionary.svg_raw-Dh36xxgl.js";
import { w as P } from "./components/BaseIcon/icons/bookmark.svg_raw-Ci0s8_7U.js";
import { w as B } from "./components/BaseIcon/icons/bookmark-filled.svg_raw-DqiKafB5.js";
import { w as D } from "./components/BaseIcon/icons/bookmark-my-projects.svg_raw-D3Pe9eZO.js";
import { w as E } from "./components/BaseIcon/icons/brain-circuit.svg_raw-BlLEzO3Q.js";
import { w as F } from "./components/BaseIcon/icons/branch-commit.svg_raw-B5WSBAts.js";
import { w as G } from "./components/BaseIcon/icons/bug.svg_raw-EygxNCFw.js";
import { w as H } from "./components/BaseIcon/icons/bulk-panel-alt.svg_raw-BfTKlrQW.js";
import { w as J } from "./components/BaseIcon/icons/buzz-bot.svg_raw-Z_tQ_CGz.js";
import { w as K } from "./components/BaseIcon/icons/camera-photo.svg_raw-B_XLqzRF.js";
import { w as L } from "./components/BaseIcon/icons/caret-close.svg_raw-D10NNCqj.js";
import { w as Q } from "./components/BaseIcon/icons/caret-open.svg_raw-BCsqGZEh.js";
import { w as R } from "./components/BaseIcon/icons/category-multimodal.svg_raw-ZNH61BQT.js";
import { w as S } from "./components/BaseIcon/icons/chart-area.svg_raw-Citn7zd8.js";
import { w as T } from "./components/BaseIcon/icons/chart-area-alt.svg_raw-iPL7CwIl.js";
import { w as U } from "./components/BaseIcon/icons/chart-area-percentage.svg_raw-CFMNx7df.js";
import { w as V } from "./components/BaseIcon/icons/chart-box-plot.svg_raw-CEpWdMfe.js";
import { w as W } from "./components/BaseIcon/icons/chart-ema-exponential.svg_raw-BqtfqZmg.js";
import { w as X } from "./components/BaseIcon/icons/chart-horizontal-bars.svg_raw-Dq0-I7AC.js";
import { w as Y } from "./components/BaseIcon/icons/chart-line.svg_raw-BulzUzqT.js";
import { w as Z } from "./components/BaseIcon/icons/chart-line-plot.svg_raw-BF67pyqH.js";
import { w as $ } from "./components/BaseIcon/icons/chart-line-plot-down.svg_raw-0SfBrgKk.js";
import { w as oo } from "./components/BaseIcon/icons/chart-line-plot-multi.svg_raw-BkwV3meQ.js";
import { w as ro } from "./components/BaseIcon/icons/chart-linear-scale.svg_raw-CvOk-61S.js";
import { w as ao } from "./components/BaseIcon/icons/chart-loess.svg_raw-QAwmSZGN.js";
import { w as to } from "./components/BaseIcon/icons/chart-logarithmic.svg_raw--TdAZ0Nf.js";
import { w as mo } from "./components/BaseIcon/icons/chart-parallel-coordinates.svg_raw-53LssX-P.js";
import { w as io } from "./components/BaseIcon/icons/chart-pie.svg_raw-C9Jdi2aG.js";
import { w as wo } from "./components/BaseIcon/icons/chart-scatterplot.svg_raw-DO-OFQFh.js";
import { w as eo } from "./components/BaseIcon/icons/chart-time-weighted-ema.svg_raw-CVYcUs2R.js";
import { w as so } from "./components/BaseIcon/icons/chart-vertical-bars.svg_raw-BKfVbsmP.js";
import { w as _o } from "./components/BaseIcon/icons/checkmark.svg_raw-gnDATF0N.js";
import { w as po } from "./components/BaseIcon/icons/checkmark-alt.svg_raw-CeJh9wsR.js";
import { w as bo } from "./components/BaseIcon/icons/checkmark-circle.svg_raw-CXaaSN7m.js";
import { w as lo } from "./components/BaseIcon/icons/checkmark2.svg_raw-CCF5vevI.js";
import { w as fo } from "./components/BaseIcon/icons/chevron-back.svg_raw-GvuXk1sl.js";
import { w as no } from "./components/BaseIcon/icons/chevron-down.svg_raw-90hwpBui.js";
import { w as co } from "./components/BaseIcon/icons/chevron-next.svg_raw-BwIaqNu5.js";
import { w as uo } from "./components/BaseIcon/icons/chevron-up.svg_raw-GHF2xeUl.js";
import { w as ho } from "./components/BaseIcon/icons/circle.svg_raw-D71XqJ_U.js";
import { w as go } from "./components/BaseIcon/icons/circle-bold.svg_raw-BFQHyBKF.js";
import { w as ko } from "./components/BaseIcon/icons/circle-dollar-sign.svg_raw-CC-DkORs.js";
import { w as yo } from "./components/BaseIcon/icons/circle-filled.svg_raw-C8b1ghXk.js";
import { w as vo } from "./components/BaseIcon/icons/clear-all.svg_raw-BaCuwCi0.js";
import { w as xo } from "./components/BaseIcon/icons/close.svg_raw-CDuNcV3w.js";
import { w as zo } from "./components/BaseIcon/icons/cloud.svg_raw-DMUxNdry.js";
import { w as jo } from "./components/BaseIcon/icons/cloud-download.svg_raw-PWwrbe2A.js";
import { w as qo } from "./components/BaseIcon/icons/cloud-upload.svg_raw-BneIgbDR.js";
import { w as Io } from "./components/BaseIcon/icons/code-alt.svg_raw-B3j-Aqkn.js";
import { w as Ao } from "./components/BaseIcon/icons/code-html.svg_raw-Chvw-98n.js";
import { w as Co } from "./components/BaseIcon/icons/code-json.svg_raw-CQD6dcnx.js";
import { w as Mo } from "./components/BaseIcon/icons/colab.svg_raw-DkgNfL1q.js";
import { w as No } from "./components/BaseIcon/icons/collapse.svg_raw-CGiy5Iz7.js";
import { w as Oo } from "./components/BaseIcon/icons/collection.svg_raw-BfFL1ieV.js";
import { w as Po } from "./components/BaseIcon/icons/color.svg_raw-DbBOiNfs.js";
import { w as Bo } from "./components/BaseIcon/icons/color-palette.svg_raw-C-NTTOQi.js";
import { w as Do } from "./components/BaseIcon/icons/column.svg_raw-CmUokoap.js";
import { w as Eo } from "./components/BaseIcon/icons/column-alt.svg_raw-C4-qOoMQ.js";
import { w as Fo } from "./components/BaseIcon/icons/combine.svg_raw-CLBZkmEt.js";
import { w as Go } from "./components/BaseIcon/icons/comments.svg_raw-R6hOOMwW.js";
import { w as Ho } from "./components/BaseIcon/icons/comments-alt.svg_raw-CB-X3q4Z.js";
import { w as Jo } from "./components/BaseIcon/icons/comments-round-alt.svg_raw-DiZaIE_W.js";
import { w as Ko } from "./components/BaseIcon/icons/compass-baseline.svg_raw-CFGZjQ0b.js";
import { w as Lo } from "./components/BaseIcon/icons/compass-baseline-alt.svg_raw-eywvbjnn.js";
import { w as Qo } from "./components/BaseIcon/icons/compose.svg_raw-Ds87FgCy.js";
import { w as Ro } from "./components/BaseIcon/icons/condition.svg_raw-Rqc5pBEp.js";
import { w as So } from "./components/BaseIcon/icons/content-full-width.svg_raw-CchcNPrg.js";
import { w as To } from "./components/BaseIcon/icons/content-narrow.svg_raw-CoKYxuCC.js";
import { w as Uo } from "./components/BaseIcon/icons/content-wide.svg_raw-C9JmccBe.js";
import { w as Vo } from "./components/BaseIcon/icons/context-window.svg_raw-CVqxdJqR.js";
import { w as Wo } from "./components/BaseIcon/icons/copy.svg_raw-BeOdYlfL.js";
import { w as Xo } from "./components/BaseIcon/icons/cost.svg_raw-CwkyiWC9.js";
import { w as Yo } from "./components/BaseIcon/icons/courthouse-license.svg_raw-HvDR9YEH.js";
import { w as Zo } from "./components/BaseIcon/icons/credit-card-payment.svg_raw-DaDKAaF5.js";
import { w as $o } from "./components/BaseIcon/icons/crop-beginning.svg_raw-DIDEkE_2.js";
import { w as or } from "./components/BaseIcon/icons/crop-end.svg_raw-DN9uilkx.js";
import { w as rr } from "./components/BaseIcon/icons/crop-middle.svg_raw-D1UDkvO9.js";
import { w as ar } from "./components/BaseIcon/icons/cross.svg_raw-BOoJzTPe.js";
import { w as tr } from "./components/BaseIcon/icons/crown-pro.svg_raw-1ruJg5IM.js";
import { w as mr } from "./components/BaseIcon/icons/cube-container.svg_raw-D4bUopUC.js";
import { w as ir } from "./components/BaseIcon/icons/curly-brackets.svg_raw-CZowDq9F.js";
import { w as wr } from "./components/BaseIcon/icons/dag.svg_raw-597rU-Ct.js";
import { w as er } from "./components/BaseIcon/icons/dashboard-blackboard.svg_raw-C3VsfuYM.js";
import { w as sr } from "./components/BaseIcon/icons/database-artifacts.svg_raw-DaAM3CzH.js";
import { w as _r } from "./components/BaseIcon/icons/date.svg_raw-DzsNFSdK.js";
import { w as pr } from "./components/BaseIcon/icons/delete.svg_raw-DnVQB9YT.js";
import { w as br } from "./components/BaseIcon/icons/desktop-responsive.svg_raw-D7s7ZfUl.js";
import { w as lr } from "./components/BaseIcon/icons/diamond.svg_raw-ClkfBd_M.js";
import { w as fr } from "./components/BaseIcon/icons/diamond-pro.svg_raw-CV4VNbZK.js";
import { w as nr } from "./components/BaseIcon/icons/diff.svg_raw-B9cM9Ub5.js";
import { w as cr } from "./components/BaseIcon/icons/discord-social.svg_raw-B9tAc9tf.js";
import { w as dr } from "./components/BaseIcon/icons/do-not-prohibited.svg_raw-BCCqR4te.js";
import { w as ur } from "./components/BaseIcon/icons/doc-left.svg_raw-DkO7Qu8A.js";
import { w as hr } from "./components/BaseIcon/icons/dock-arrow.svg_raw-DjZYKZLC.js";
import { w as gr } from "./components/BaseIcon/icons/docker-whale.svg_raw-Dfutcbbu.js";
import { w as kr } from "./components/BaseIcon/icons/document.svg_raw-Dcppf1Xo.js";
import { w as yr } from "./components/BaseIcon/icons/documentation.svg_raw-B0gOlg9g.js";
import { w as vr } from "./components/BaseIcon/icons/down.svg_raw-CnY__zk-.js";
import { w as xr } from "./components/BaseIcon/icons/download.svg_raw-CU8JYM3q.js";
import { w as zr } from "./components/BaseIcon/icons/draft-manual.svg_raw-BT57jDOt.js";
import { w as jr } from "./components/BaseIcon/icons/drag-grip.svg_raw-DyioAQzZ.js";
import { w as qr } from "./components/BaseIcon/icons/dumbbell.svg_raw-C8Dqzzgm.js";
import { w as Ir } from "./components/BaseIcon/icons/education-academic.svg_raw-Bzl8sdTD.js";
import { w as Ar } from "./components/BaseIcon/icons/email-at.svg_raw-CBE7qSWo.js";
import { w as Cr } from "./components/BaseIcon/icons/email-envelope.svg_raw-6czs_5n8.js";
import { w as Mr } from "./components/BaseIcon/icons/enter-return.svg_raw-DaxnZ9H-.js";
import { w as Nr } from "./components/BaseIcon/icons/enter-switch.svg_raw-Cu2QbPuD.js";
import { w as Or } from "./components/BaseIcon/icons/enterprise-corporate.svg_raw-Co1mhdZF.js";
import { w as Pr } from "./components/BaseIcon/icons/expand-down.svg_raw-DstOIdQr.js";
import { w as Br } from "./components/BaseIcon/icons/expand-left.svg_raw-CFGgDW6J.js";
import { w as Dr } from "./components/BaseIcon/icons/expand-right.svg_raw-RhE6NmtB.js";
import { w as Er } from "./components/BaseIcon/icons/expand-uncollapse.svg_raw-C2ULeSYS.js";
import { w as Fr } from "./components/BaseIcon/icons/expand-up.svg_raw-oiB7ftwp.js";
import { w as Gr } from "./components/BaseIcon/icons/explosion.svg_raw-POYaqh1Z.js";
import { w as Hr } from "./components/BaseIcon/icons/export-share-upload.svg_raw-C-caNa1B.js";
import { w as Jr } from "./components/BaseIcon/icons/extract.svg_raw-D8kVn_yX.js";
import { w as Kr } from "./components/BaseIcon/icons/extract-break.svg_raw-3Sozt7M1.js";
import { w as Lr } from "./components/BaseIcon/icons/facebook-social.svg_raw-Dj2j9gpo.js";
import { w as Qr } from "./components/BaseIcon/icons/factory.svg_raw-DRwSds9D.js";
import { w as Rr } from "./components/BaseIcon/icons/failed-error-deleted.svg_raw-MXFyXnC3.js";
import { w as Sr } from "./components/BaseIcon/icons/feather.svg_raw-CE8cLNeZ.js";
import { w as Tr } from "./components/BaseIcon/icons/feather-alt.svg_raw-Elce2U3u.js";
import { w as Ur } from "./components/BaseIcon/icons/filter-alt.svg_raw-BPjoYYP4.js";
import { w as Vr } from "./components/BaseIcon/icons/flash-bolt.svg_raw-BOUlYvts.js";
import { w as Wr } from "./components/BaseIcon/icons/folder-eye.svg_raw-BhNfeaSj.js";
import { w as Xr } from "./components/BaseIcon/icons/folder-fill.svg_raw-CLQMnIpo.js";
import { w as Yr } from "./components/BaseIcon/icons/folder-project.svg_raw-BzKQn7Z5.js";
import { w as Zr } from "./components/BaseIcon/icons/folder-project-move.svg_raw-BIvrDj9z.js";
import { w as $r } from "./components/BaseIcon/icons/footprints.svg_raw-issxTElQ.js";
import { w as oa } from "./components/BaseIcon/icons/forum-chat-bubble.svg_raw-Bspl37BD.js";
import { w as ra } from "./components/BaseIcon/icons/forward-next.svg_raw-BJG0wRWb.js";
import { w as aa } from "./components/BaseIcon/icons/freeze-snowflake.svg_raw-CMCB9-7D.js";
import { w as ta } from "./components/BaseIcon/icons/freeze-snowflake-alt.svg_raw-DguFPIq7.js";
import { w as ma } from "./components/BaseIcon/icons/full-screen-mode-expand.svg_raw-BtaeDyUT.js";
import { w as ia } from "./components/BaseIcon/icons/ghost-agent.svg_raw-BusynqCJ.js";
import { w as wa } from "./components/BaseIcon/icons/git.svg_raw-mZnZUoBf.js";
import { w as ea } from "./components/BaseIcon/icons/github.svg_raw-BSbqpH_A.js";
import { w as sa } from "./components/BaseIcon/icons/grafana.svg_raw-CiWSGBda.js";
import { w as _a } from "./components/BaseIcon/icons/grafana-mono.svg_raw-XyAyVWFy.js";
import { w as pa } from "./components/BaseIcon/icons/group.svg_raw-CMk_DGak.js";
import { w as ba } from "./components/BaseIcon/icons/hand-fist.svg_raw-B6UEOQn7.js";
import { w as la } from "./components/BaseIcon/icons/hand-manual.svg_raw-Cj_yms0q.js";
import { w as fa } from "./components/BaseIcon/icons/headset.svg_raw-B_X7TVfh.js";
import { w as na } from "./components/BaseIcon/icons/heart.svg_raw-1rArWV6Y.js";
import { w as ca } from "./components/BaseIcon/icons/heart-filled.svg_raw-CQdW_uga.js";
import { w as da } from "./components/BaseIcon/icons/help-alt.svg_raw-LDmwwd_I.js";
import { w as ua } from "./components/BaseIcon/icons/help-resources.svg_raw-BCJxuvC0.js";
import { w as ha } from "./components/BaseIcon/icons/hide.svg_raw-B7JHsA3Z.js";
import { w as ga } from "./components/BaseIcon/icons/history.svg_raw-nfHfTtR2.js";
import { w as ka } from "./components/BaseIcon/icons/home.svg_raw-D6_nxkpE.js";
import { w as ya } from "./components/BaseIcon/icons/hospital.svg_raw-DXv-trE-.js";
import { w as va } from "./components/BaseIcon/icons/hourglass.svg_raw-Cx-0iCnP.js";
import { w as xa } from "./components/BaseIcon/icons/hourglass-alt.svg_raw-BcOhq0Jf.js";
import { w as za } from "./components/BaseIcon/icons/idle.svg_raw-Cc40kkjP.js";
import { w as ja } from "./components/BaseIcon/icons/ignore-outliers.svg_raw-BDc3fD6t.js";
import { w as qa } from "./components/BaseIcon/icons/impersonate-mask.svg_raw-BfjgL30v.js";
import { w as Ia } from "./components/BaseIcon/icons/impersonate-mask-alt.svg_raw-BDc56msI.js";
import { w as Aa } from "./components/BaseIcon/icons/import-corner-arrow.svg_raw-BUXUJiu1.js";
import { w as Ca } from "./components/BaseIcon/icons/import-insert.svg_raw-0sOXnuFY.js";
import { w as Ma } from "./components/BaseIcon/icons/inference.svg_raw-DoODZnPx.js";
import { w as Na } from "./components/BaseIcon/icons/infinity-auto.svg_raw-DMbXja-C.js";
import { w as Oa } from "./components/BaseIcon/icons/info.svg_raw-BPUJf6-0.js";
import { w as Pa } from "./components/BaseIcon/icons/isolate.svg_raw-BKSTycis.js";
import { w as Ba } from "./components/BaseIcon/icons/italic.svg_raw-DDZWiKfb.js";
import { w as Da } from "./components/BaseIcon/icons/job-automation.svg_raw-BY5yYWr1.js";
import { w as Ea } from "./components/BaseIcon/icons/job-calculator.svg_raw-janXIgQi.js";
import { w as Fa } from "./components/BaseIcon/icons/job-program-code.svg_raw-BK3mRiPU.js";
import { w as Ga } from "./components/BaseIcon/icons/keras.svg_raw-DP6_o0HM.js";
import { w as Ha } from "./components/BaseIcon/icons/key-admin.svg_raw-DZMl0i4l.js";
import { w as Ja } from "./components/BaseIcon/icons/key-admin-private.svg_raw-XY7HWnf9.js";
import { w as Ka } from "./components/BaseIcon/icons/keyboard.svg_raw-DNaQZytB.js";
import { w as La } from "./components/BaseIcon/icons/kubernetes.svg_raw-vGNyfeSs.js";
import { w as Qa } from "./components/BaseIcon/icons/languages.svg_raw-CQ9bPUrX.js";
import { w as Ra } from "./components/BaseIcon/icons/laptop-local-computer.svg_raw-BUVe-jaB.js";
import { w as Sa } from "./components/BaseIcon/icons/layout-grid.svg_raw-CSI3BkoY.js";
import { w as Ta } from "./components/BaseIcon/icons/layout-horizontal.svg_raw-ShXKbNhR.js";
import { w as Ua } from "./components/BaseIcon/icons/layout-mixed.svg_raw-BJ9Zkei-.js";
import { w as Va } from "./components/BaseIcon/icons/layout-split.svg_raw-DYJXT4KA.js";
import { w as Wa } from "./components/BaseIcon/icons/layout-tabs.svg_raw-BfuKGTjF.js";
import { w as Xa } from "./components/BaseIcon/icons/layout-vertical.svg_raw-BRIEm0Rk.js";
import { w as Ya } from "./components/BaseIcon/icons/leaf.svg_raw-CoysI3VA.js";
import { w as Za } from "./components/BaseIcon/icons/lightboard.svg_raw-DxSD1a2k.js";
import { w as $a } from "./components/BaseIcon/icons/lightboard-solid.svg_raw-C_fI4r0R.js";
import { w as ot } from "./components/BaseIcon/icons/lightbulb-info.svg_raw-RKVQ9qK6.js";
import { w as rt } from "./components/BaseIcon/icons/linear-scale-1.svg_raw-BNAI0BXS.js";
import { w as at } from "./components/BaseIcon/icons/link-alt.svg_raw-DONbTPFi.js";
import { w as tt } from "./components/BaseIcon/icons/list-bullets.svg_raw-B8utLf6-.js";
import { w as mt } from "./components/BaseIcon/icons/list-bullets-alt.svg_raw-cdVr4CeT.js";
import { w as it } from "./components/BaseIcon/icons/list-numbered.svg_raw-x_8gMZmz.js";
import { w as wt } from "./components/BaseIcon/icons/listing.svg_raw-B-PHa3xU.js";
import { w as et } from "./components/BaseIcon/icons/loading.svg_raw-Ds5Hdq67.js";
import { w as st } from "./components/BaseIcon/icons/location-pin.svg_raw-C7eJBLI8.js";
import { w as _t } from "./components/BaseIcon/icons/lock-closed.svg_raw-CPy5yXqL.js";
import { w as pt } from "./components/BaseIcon/icons/lock-open.svg_raw-DUjj9sxJ.js";
import { w as bt } from "./components/BaseIcon/icons/locked-constrained.svg_raw-D48KdsdO.js";
import { w as lt } from "./components/BaseIcon/icons/log-in.svg_raw-BSRjLkce.js";
import { w as ft } from "./components/BaseIcon/icons/log-out.svg_raw-BpEWy3B8.js";
import { w as nt } from "./components/BaseIcon/icons/log-scale-x.svg_raw-ClqkfKCN.js";
import { w as ct } from "./components/BaseIcon/icons/log-scale-y.svg_raw-FQXtnhax.js";
import { w as dt } from "./components/BaseIcon/icons/magic-wand-star.svg_raw-C7iIG9-C.js";
import { w as ut } from "./components/BaseIcon/icons/magic-wand-stick.svg_raw-Du5rIaq-.js";
import { w as ht } from "./components/BaseIcon/icons/marimo.svg_raw-B6K8bkXb.js";
import { w as gt } from "./components/BaseIcon/icons/marker.svg_raw-MjW1plP7.js";
import { w as kt } from "./components/BaseIcon/icons/megaphone.svg_raw-DBwqUL2w.js";
import { w as yt } from "./components/BaseIcon/icons/menu.svg_raw-Dd44P52C.js";
import { w as vt } from "./components/BaseIcon/icons/microphone-audio.svg_raw-B3dA1J5M.js";
import { w as xt } from "./components/BaseIcon/icons/miller-columns.svg_raw-mjeE7Zq0.js";
import { w as zt } from "./components/BaseIcon/icons/minimize-mode.svg_raw-DcJvXIw8.js";
import { w as jt } from "./components/BaseIcon/icons/mobile-responsive.svg_raw-GGnqplOj.js";
import { w as qt } from "./components/BaseIcon/icons/model.svg_raw-C_GFqP1V.js";
import { w as It } from "./components/BaseIcon/icons/molecule.svg_raw-DS63AarK.js";
import { w as At } from "./components/BaseIcon/icons/monitors.svg_raw-kar7kWzX.js";
import { w as Ct } from "./components/BaseIcon/icons/moon.svg_raw-CrXNtko3.js";
import { w as Mt } from "./components/BaseIcon/icons/multi-select.svg_raw-L00zR3d3.js";
import { w as Nt } from "./components/BaseIcon/icons/music-audio.svg_raw-Lnnz7Hw_.js";
import { w as Ot } from "./components/BaseIcon/icons/new-section-above.svg_raw-BVVn2H8h.js";
import { w as Pt } from "./components/BaseIcon/icons/new-section-below.svg_raw-D4VEaGQa.js";
import { w as Bt } from "./components/BaseIcon/icons/notebook.svg_raw-BSZ38XYz.js";
import { w as Dt } from "./components/BaseIcon/icons/number-hashtag.svg_raw-Bnml9Zla.js";
import { w as Et } from "./components/BaseIcon/icons/open-new-tab.svg_raw-Djg86FFt.js";
import { w as Ft } from "./components/BaseIcon/icons/orchestration-launch.svg_raw-y04LSdPA.js";
import { w as Gt } from "./components/BaseIcon/icons/organization-corporate.svg_raw-iNxYQzXL.js";
import { w as Ht } from "./components/BaseIcon/icons/overflow-horizontal.svg_raw-DsAediz5.js";
import { w as Jt } from "./components/BaseIcon/icons/pan-tool.svg_raw-Cra_WGoP.js";
import { w as Kt } from "./components/BaseIcon/icons/pan-tool-1.svg_raw-BEMQPdoS.js";
import { w as Lt } from "./components/BaseIcon/icons/panel.svg_raw-BOS-ETt5.js";
import { w as Qt } from "./components/BaseIcon/icons/panel-auto-gen.svg_raw-sXbSdDjb.js";
import { w as Rt } from "./components/BaseIcon/icons/panel-hide-icon-closed-eye.svg_raw-C9ywNMHO.js";
import { w as St } from "./components/BaseIcon/icons/panel-manual.svg_raw-Csev6Ev6.js";
import { w as Tt } from "./components/BaseIcon/icons/paragraph.svg_raw-CMjUjZ-8.js";
import { w as Ut } from "./components/BaseIcon/icons/parent-back-up.svg_raw-5vj8N9oi.js";
import { w as Vt } from "./components/BaseIcon/icons/party-popper.svg_raw-Dve03NLu.js";
import { w as Wt } from "./components/BaseIcon/icons/pause.svg_raw-F3Vz2LGh.js";
import { w as Xt } from "./components/BaseIcon/icons/paused.svg_raw-gaMtgJkI.js";
import { w as Yt } from "./components/BaseIcon/icons/pencil-edit.svg_raw-BHJoQ18L.js";
import { w as Zt } from "./components/BaseIcon/icons/phone.svg_raw-BWnMc8kM.js";
import { w as $t } from "./components/BaseIcon/icons/photo-picture.svg_raw-BNFxIqaf.js";
import { w as om } from "./components/BaseIcon/icons/pin.svg_raw-C0e_bWf5.js";
import { w as rm } from "./components/BaseIcon/icons/pin-filled.svg_raw-NeQijlZ-.js";
import { w as am } from "./components/BaseIcon/icons/plane.svg_raw-CJpdlovc.js";
import { w as tm } from "./components/BaseIcon/icons/play.svg_raw-Br1L3CQD.js";
import { w as mm } from "./components/BaseIcon/icons/plotly.svg_raw-DXA6yzIA.js";
import { w as im } from "./components/BaseIcon/icons/privacy-open.svg_raw-hfMS8T8u.js";
import { w as wm } from "./components/BaseIcon/icons/privacy-team-private.svg_raw-D5a--uVo.js";
import { w as em } from "./components/BaseIcon/icons/privacy-team-public.svg_raw-DTzV_InA.js";
import { w as sm } from "./components/BaseIcon/icons/privacy-user-private.svg_raw-C5hvnBhG.js";
import { w as _m } from "./components/BaseIcon/icons/privacy-user-public.svg_raw-Btd8rA-R.js";
import { w as pm } from "./components/BaseIcon/icons/python.svg_raw-nxCS_yE7.js";
import { w as bm } from "./components/BaseIcon/icons/pytorch.svg_raw-B0ngpzuV.js";
import { w as lm } from "./components/BaseIcon/icons/pytorch-lightning.svg_raw-CTWGvAPG.js";
import { w as fm } from "./components/BaseIcon/icons/queue.svg_raw-uH6hIli1.js";
import { w as nm } from "./components/BaseIcon/icons/queued.svg_raw-DjTxTwC_.js";
import { w as cm } from "./components/BaseIcon/icons/quickstart-code.svg_raw-Be-0Xhan.js";
import { w as dm } from "./components/BaseIcon/icons/radio-tower.svg_raw-DzEGsO06.js";
import { w as um } from "./components/BaseIcon/icons/randomize.svg_raw-D_2vIqe1.js";
import { w as hm } from "./components/BaseIcon/icons/randomize-alt.svg_raw-BaqX1ceV.js";
import { w as gm } from "./components/BaseIcon/icons/reasoning.svg_raw-D34a5voo.js";
import { w as km } from "./components/BaseIcon/icons/receipt-text.svg_raw-DKS2yAPM.js";
import { w as ym } from "./components/BaseIcon/icons/recent-clock.svg_raw-GzUTq1p5.js";
import { w as vm } from "./components/BaseIcon/icons/reddit-social.svg_raw-eYna55yD.js";
import { w as xm } from "./components/BaseIcon/icons/redo.svg_raw-B8I91Ngp.js";
import { w as zm } from "./components/BaseIcon/icons/regex.svg_raw-BeJwhrre.js";
import { w as jm } from "./components/BaseIcon/icons/registries.svg_raw-CaJTxuXu.js";
import { w as qm } from "./components/BaseIcon/icons/reload-refresh.svg_raw-TcI_PgAD.js";
import { w as Im } from "./components/BaseIcon/icons/remove.svg_raw-DiukjvT8.js";
import { w as Am } from "./components/BaseIcon/icons/remove-alt.svg_raw-Dlrp_0-H.js";
import { w as Cm } from "./components/BaseIcon/icons/report.svg_raw-CqJj61uy.js";
import { w as Mm } from "./components/BaseIcon/icons/reset.svg_raw-BRHjl7EH.js";
import { w as Nm } from "./components/BaseIcon/icons/retry-swap.svg_raw-DyZMXBTj.js";
import { w as Om } from "./components/BaseIcon/icons/robot-service-member.svg_raw-B4xZ_PwY.js";
import { w as Pm } from "./components/BaseIcon/icons/rocket-launch.svg_raw-DTSYXC4X.js";
import { w as Bm } from "./components/BaseIcon/icons/rowheight-l.svg_raw-CV2HU-jG.js";
import { w as Dm } from "./components/BaseIcon/icons/rowheight-m.svg_raw-C4qI43bW.js";
import { w as Em } from "./components/BaseIcon/icons/rowheight-s.svg_raw-CbGqN1jv.js";
import { w as Fm } from "./components/BaseIcon/icons/rowheight-xl.svg_raw-UgWN7UVU.js";
import { w as Gm } from "./components/BaseIcon/icons/run-set-subset.svg_raw-UZgDNz1d.js";
import { w as Hm } from "./components/BaseIcon/icons/run-set-universe.svg_raw-D3XYs3IE.js";
import { w as Jm } from "./components/BaseIcon/icons/running-repeat.svg_raw-BaqX1ceV.js";
import { w as Km } from "./components/BaseIcon/icons/sandbox-playground.svg_raw-DD_r-oi3.js";
import { w as Lm } from "./components/BaseIcon/icons/save.svg_raw-JPUKnUHV.js";
import { w as Qm } from "./components/BaseIcon/icons/scale-down.svg_raw-2_wtvnjw.js";
import { w as Rm } from "./components/BaseIcon/icons/scale-up.svg_raw-CIJ67ZNx.js";
import { w as Sm } from "./components/BaseIcon/icons/scikit.svg_raw-aemEVgus.js";
import { w as Tm } from "./components/BaseIcon/icons/search.svg_raw-DzCA6Na5.js";
import { w as Um } from "./components/BaseIcon/icons/search-results.svg_raw-DyMTp1jd.js";
import { w as Vm } from "./components/BaseIcon/icons/section.svg_raw-DcM4C3CT.js";
import { w as Wm } from "./components/BaseIcon/icons/seed-propagate.svg_raw-D9jMXOsX.js";
import { w as Xm } from "./components/BaseIcon/icons/select-marquee-tool.svg_raw-aeE-voxO.js";
import { w as Ym } from "./components/BaseIcon/icons/select-move-tool.svg_raw-CPjbb2w1.js";
import { w as Zm } from "./components/BaseIcon/icons/settings.svg_raw-DSbJEZO9.js";
import { w as $m } from "./components/BaseIcon/icons/settings-parameters.svg_raw-D0reTY4-.js";
import { w as oi } from "./components/BaseIcon/icons/shield-protected.svg_raw-BOvGjk92.js";
import { w as ri } from "./components/BaseIcon/icons/shield-remove.svg_raw-HnqMsZlD.js";
import { w as ai } from "./components/BaseIcon/icons/shopping-cart.svg_raw-k6sturMh.js";
import { w as ti } from "./components/BaseIcon/icons/sidebar.svg_raw-DvI7Sm9C.js";
import { w as mi } from "./components/BaseIcon/icons/sidebar-collapse.svg_raw-Db9bwY52.js";
import { w as ii } from "./components/BaseIcon/icons/sidebar-reveal.svg_raw-CsEOID2C.js";
import { w as wi } from "./components/BaseIcon/icons/slack.svg_raw-DBhkvS9x.js";
import { w as ei } from "./components/BaseIcon/icons/smoothing.svg_raw-COqGN6_y.js";
import { w as si } from "./components/BaseIcon/icons/sort.svg_raw-CaMyAhqj.js";
import { w as _i } from "./components/BaseIcon/icons/sort-direction.svg_raw-DzHOWQR6.js";
import { w as pi } from "./components/BaseIcon/icons/spiral.svg_raw-NM9nWMvw.js";
import { w as bi } from "./components/BaseIcon/icons/split.svg_raw-CuNgqoz8.js";
import { w as li } from "./components/BaseIcon/icons/square.svg_raw-CmLYnReB.js";
import { w as fi } from "./components/BaseIcon/icons/star.svg_raw-BtzxwSyn.js";
import { w as ni } from "./components/BaseIcon/icons/star-filled.svg_raw-FUOy_nvD.js";
import { w as ci } from "./components/BaseIcon/icons/stop.svg_raw-CmLYnReB.js";
import { w as di } from "./components/BaseIcon/icons/stopped.svg_raw-DeOjDlwd.js";
import { w as ui } from "./components/BaseIcon/icons/strikethrough.svg_raw-CZRGo-Zk.js";
import { w as hi } from "./components/BaseIcon/icons/sun.svg_raw-DYyCKSbT.js";
import { w as gi } from "./components/BaseIcon/icons/sweep-bayes.svg_raw-0Xol1zKA.js";
import { w as ki } from "./components/BaseIcon/icons/sweep-grid.svg_raw-Bpvn9k7O.js";
import { w as yi } from "./components/BaseIcon/icons/sweep-random-search.svg_raw-Cad3_Bu1.js";
import { w as vi } from "./components/BaseIcon/icons/sweeps-alt.svg_raw-DYIJ6wUO.js";
import { w as xi } from "./components/BaseIcon/icons/sweeps-broom.svg_raw-L6Szkvem.js";
import { w as zi } from "./components/BaseIcon/icons/switch-account.svg_raw-B17NNJxD.js";
import { w as ji } from "./components/BaseIcon/icons/system.svg_raw-6mTajSfb.js";
import { w as qi } from "./components/BaseIcon/icons/system-chip.svg_raw-CXT0Pc2G.js";
import { w as Ii } from "./components/BaseIcon/icons/system-chip-alt.svg_raw-C62jGc0T.js";
import { w as Ai } from "./components/BaseIcon/icons/table.svg_raw-P5lSazsH.js";
import { w as Ci } from "./components/BaseIcon/icons/tablet-responsive.svg_raw-DFS75NeM.js";
import { w as Mi } from "./components/BaseIcon/icons/tag.svg_raw-DpceeBr2.js";
import { w as Ni } from "./components/BaseIcon/icons/tensorflow.svg_raw-v8CuxMKE.js";
import { w as Oi } from "./components/BaseIcon/icons/text-language.svg_raw-DDjR6Hwr.js";
import { w as Pi } from "./components/BaseIcon/icons/text-language-alt.svg_raw-CxRUid7z.js";
import { w as Bi } from "./components/BaseIcon/icons/threads.svg_raw-DEAAkbpZ.js";
import { w as Di } from "./components/BaseIcon/icons/thumbs-down.svg_raw-C0QrygMW.js";
import { w as Ei } from "./components/BaseIcon/icons/thumbs-up.svg_raw-Csygjc4a.js";
import { w as Fi } from "./components/BaseIcon/icons/token.svg_raw-Cor7fl9r.js";
import { w as Gi } from "./components/BaseIcon/icons/treeview.svg_raw-DB3GanZq.js";
import { w as Hi } from "./components/BaseIcon/icons/triangle-alert.svg_raw-B0-kh6r9.js";
import { w as Ji } from "./components/BaseIcon/icons/triangle-down.svg_raw-CD0DX1L0.js";
import { w as Ki } from "./components/BaseIcon/icons/triangle-left.svg_raw-CQlsQgM6.js";
import { w as Li } from "./components/BaseIcon/icons/triangle-right.svg_raw-Br1L3CQD.js";
import { w as Qi } from "./components/BaseIcon/icons/triangle-up.svg_raw-CBU4N8Xm.js";
import { w as Ri } from "./components/BaseIcon/icons/truck.svg_raw-C_UnSHwE.js";
import { w as Si } from "./components/BaseIcon/icons/type-boolean.svg_raw-B5fiNd-z.js";
import { w as Ti } from "./components/BaseIcon/icons/type-number.svg_raw-LLOpBzKe.js";
import { w as Ui } from "./components/BaseIcon/icons/type-number-alt.svg_raw-Dtvi7uPk.js";
import { w as Vi } from "./components/BaseIcon/icons/type-string-alt.svg_raw-CroXoOBc.js";
import { w as Wi } from "./components/BaseIcon/icons/type-string-quote.svg_raw-mw8BMwfm.js";
import { w as Xi } from "./components/BaseIcon/icons/unassigned-01.svg_raw-Md6azGif.js";
import { w as Yi } from "./components/BaseIcon/icons/unassigned-02.svg_raw-CDdup_L_.js";
import { w as Zi } from "./components/BaseIcon/icons/undo.svg_raw-Byaush9i.js";
import { w as $i } from "./components/BaseIcon/icons/undock.svg_raw-jOkpGQ2V.js";
import { w as ow } from "./components/BaseIcon/icons/unified-diff.svg_raw-DECD46sd.js";
import { w as rw } from "./components/BaseIcon/icons/unlocked-unconstrained.svg_raw-CJBpDmV8.js";
import { w as aw } from "./components/BaseIcon/icons/up.svg_raw-w27rOcR1.js";
import { w as tw } from "./components/BaseIcon/icons/user-author.svg_raw-_uBmWPBk.js";
import { w as mw } from "./components/BaseIcon/icons/user-profile-personal.svg_raw-Dnt23oqL.js";
import { w as iw } from "./components/BaseIcon/icons/users-team.svg_raw-BAGF5qKZ.js";
import { w as ww } from "./components/BaseIcon/icons/uuid-identifier.svg_raw-BkPY78oe.js";
import { w as ew } from "./components/BaseIcon/icons/versions-layers.svg_raw-B_zroDGD.js";
import { w as sw } from "./components/BaseIcon/icons/vertex-gcp.svg_raw-DqfqtDzC.js";
import { w as _w } from "./components/BaseIcon/icons/video-play.svg_raw-COMPW8TH.js";
import { w as pw } from "./components/BaseIcon/icons/view-alt.svg_raw-DzOYvJ6g.js";
import { w as bw } from "./components/BaseIcon/icons/view-glasses.svg_raw-DQnSDxDE.js";
import { w as lw } from "./components/BaseIcon/icons/visibility-checked.svg_raw-5fc6rJaX.js";
import { w as fw } from "./components/BaseIcon/icons/visibility-indeterminate.svg_raw-Bv084hJl.js";
import { w as nw } from "./components/BaseIcon/icons/visibility-unchecked.svg_raw-CMiS5XZS.js";
import { w as cw } from "./components/BaseIcon/icons/volleyball.svg_raw-BSQOKbXr.js";
import { w as dw } from "./components/BaseIcon/icons/wandb.svg_raw-D8_oHhJE.js";
import { w as uw } from "./components/BaseIcon/icons/warning.svg_raw-BlD_jeVk.js";
import { w as hw } from "./components/BaseIcon/icons/weave.svg_raw-DQOjgjVE.js";
import { w as gw } from "./components/BaseIcon/icons/webhook.svg_raw-DmQsMIur.js";
import { w as kw } from "./components/BaseIcon/icons/webhook-alt.svg_raw-CEPnQKZL.js";
import { w as yw } from "./components/BaseIcon/icons/wrap.svg_raw-CpyscVEB.js";
import { w as vw } from "./components/BaseIcon/icons/wrench.svg_raw-BYIMfaos.js";
import { w as xw } from "./components/BaseIcon/icons/x-axi-alt.svg_raw-woGQSJox.js";
import { w as zw } from "./components/BaseIcon/icons/x-axis.svg_raw-DBgKJp6X.js";
import { w as jw } from "./components/BaseIcon/icons/x-social.svg_raw-CuLAl7Nt.js";
import { w as qw } from "./components/BaseIcon/icons/youtube-social.svg_raw-P_Gqtnke.js";
import { w as Iw } from "./components/BaseIcon/icons/zoom-alt-tool.svg_raw-DEPka0E6.js";
import { w as Aw } from "./components/BaseIcon/icons/zoom-in-tool.svg_raw-CuaOIv98.js";
import { w as Cw } from "./components/BaseIcon/icons/zoom-out-tool.svg_raw-B2inlXGY.js";
const en = {
  "1x": o,
  "2x": r,
  "4x": a,
  activity: t,
  "add-comment": m,
  "add-comments-round-alt": i,
  "add-new": w,
  "add-panel": e,
  "add-reaction": s,
  "add-to-report": _,
  "admin-shield-safe": p,
  "agent-stop": b,
  "alias-alt": l,
  "alias-protected": f,
  "amazon-sagemaker": n,
  apps: c,
  "arrow-up-from-line": d,
  "artifact-type": u,
  "artifact-type-alt": h,
  attachment: g,
  "audio-volume": k,
  "automation-robot-arm": y,
  baby: v,
  back: x,
  "baseline-alt": z,
  "bell-notifications": j,
  "benchmark-square": q,
  bike: I,
  "blog-alt": A,
  "blog-report": C,
  bokeh: M,
  bold: N,
  "book-dictionary": O,
  bookmark: P,
  "bookmark-filled": B,
  "bookmark-my-projects": D,
  "brain-circuit": E,
  "branch-commit": F,
  bug: G,
  "bulk-panel-alt": H,
  "buzz-bot": J,
  "camera-photo": K,
  "caret-close": L,
  "caret-open": Q,
  "category-multimodal": R,
  "chart-area": S,
  "chart-area-alt": T,
  "chart-area-percentage": U,
  "chart-box-plot": V,
  "chart-ema-exponential": W,
  "chart-horizontal-bars": X,
  "chart-line": Y,
  "chart-line-plot": Z,
  "chart-line-plot-down": $,
  "chart-line-plot-multi": oo,
  "chart-linear-scale": ro,
  "chart-loess": ao,
  "chart-logarithmic": to,
  "chart-parallel-coordinates": mo,
  "chart-pie": io,
  "chart-scatterplot": wo,
  "chart-time-weighted-ema": eo,
  "chart-vertical-bars": so,
  checkmark: _o,
  "checkmark-alt": po,
  "checkmark-circle": bo,
  checkmark2: lo,
  "chevron-back": fo,
  "chevron-down": no,
  "chevron-next": co,
  "chevron-up": uo,
  circle: ho,
  "circle-bold": go,
  "circle-dollar-sign": ko,
  "circle-filled": yo,
  "clear-all": vo,
  close: xo,
  cloud: zo,
  "cloud-download": jo,
  "cloud-upload": qo,
  "code-alt": Io,
  "code-html": Ao,
  "code-json": Co,
  colab: Mo,
  collapse: No,
  collection: Oo,
  color: Po,
  "color-palette": Bo,
  column: Do,
  "column-alt": Eo,
  combine: Fo,
  comments: Go,
  "comments-alt": Ho,
  "comments-round-alt": Jo,
  "compass-baseline": Ko,
  "compass-baseline-alt": Lo,
  compose: Qo,
  condition: Ro,
  "content-full-width": So,
  "content-narrow": To,
  "content-wide": Uo,
  "context-window": Vo,
  copy: Wo,
  cost: Xo,
  "courthouse-license": Yo,
  "credit-card-payment": Zo,
  "crop-beginning": $o,
  "crop-end": or,
  "crop-middle": rr,
  cross: ar,
  "crown-pro": tr,
  "cube-container": mr,
  "curly-brackets": ir,
  dag: wr,
  "dashboard-blackboard": er,
  "database-artifacts": sr,
  date: _r,
  delete: pr,
  "desktop-responsive": br,
  diamond: lr,
  "diamond-pro": fr,
  diff: nr,
  "discord-social": cr,
  "do-not-prohibited": dr,
  "doc-left": ur,
  "dock-arrow": hr,
  "docker-whale": gr,
  document: kr,
  documentation: yr,
  down: vr,
  download: xr,
  "draft-manual": zr,
  "drag-grip": jr,
  dumbbell: qr,
  "education-academic": Ir,
  "email-at": Ar,
  "email-envelope": Cr,
  "enter-return": Mr,
  "enter-switch": Nr,
  "enterprise-corporate": Or,
  "expand-down": Pr,
  "expand-left": Br,
  "expand-right": Dr,
  "expand-uncollapse": Er,
  "expand-up": Fr,
  explosion: Gr,
  "export-share-upload": Hr,
  extract: Jr,
  "extract-break": Kr,
  "facebook-social": Lr,
  factory: Qr,
  "failed-error-deleted": Rr,
  feather: Sr,
  "feather-alt": Tr,
  "filter-alt": Ur,
  "flash-bolt": Vr,
  "folder-eye": Wr,
  "folder-fill": Xr,
  "folder-project": Yr,
  "folder-project-move": Zr,
  footprints: $r,
  "forum-chat-bubble": oa,
  "forward-next": ra,
  "freeze-snowflake": aa,
  "freeze-snowflake-alt": ta,
  "full-screen-mode-expand": ma,
  "ghost-agent": ia,
  git: wa,
  github: ea,
  grafana: sa,
  "grafana-mono": _a,
  group: pa,
  "hand-fist": ba,
  "hand-manual": la,
  headset: fa,
  heart: na,
  "heart-filled": ca,
  "help-alt": da,
  "help-resources": ua,
  hide: ha,
  history: ga,
  home: ka,
  hospital: ya,
  hourglass: va,
  "hourglass-alt": xa,
  idle: za,
  "ignore-outliers": ja,
  "impersonate-mask": qa,
  "impersonate-mask-alt": Ia,
  "import-corner-arrow": Aa,
  "import-insert": Ca,
  inference: Ma,
  "infinity-auto": Na,
  info: Oa,
  isolate: Pa,
  italic: Ba,
  "job-automation": Da,
  "job-calculator": Ea,
  "job-program-code": Fa,
  keras: Ga,
  "key-admin": Ha,
  "key-admin-private": Ja,
  keyboard: Ka,
  kubernetes: La,
  languages: Qa,
  "laptop-local-computer": Ra,
  "layout-grid": Sa,
  "layout-horizontal": Ta,
  "layout-mixed": Ua,
  "layout-split": Va,
  "layout-tabs": Wa,
  "layout-vertical": Xa,
  leaf: Ya,
  lightboard: Za,
  "lightboard-solid": $a,
  "lightbulb-info": ot,
  "linear-scale-1": rt,
  "link-alt": at,
  "list-bullets": tt,
  "list-bullets-alt": mt,
  "list-numbered": it,
  listing: wt,
  loading: et,
  "location-pin": st,
  "lock-closed": _t,
  "lock-open": pt,
  "locked-constrained": bt,
  "log-in": lt,
  "log-out": ft,
  "log-scale-x": nt,
  "log-scale-y": ct,
  "magic-wand-star": dt,
  "magic-wand-stick": ut,
  marimo: ht,
  marker: gt,
  megaphone: kt,
  menu: yt,
  "microphone-audio": vt,
  "miller-columns": xt,
  "minimize-mode": zt,
  "mobile-responsive": jt,
  model: qt,
  molecule: It,
  monitors: At,
  moon: Ct,
  "multi-select": Mt,
  "music-audio": Nt,
  "new-section-above": Ot,
  "new-section-below": Pt,
  notebook: Bt,
  "number-hashtag": Dt,
  "open-new-tab": Et,
  "orchestration-launch": Ft,
  "organization-corporate": Gt,
  "overflow-horizontal": Ht,
  "pan-tool": Jt,
  "pan-tool-1": Kt,
  panel: Lt,
  "panel-auto-gen": Qt,
  "panel-hide-icon-closed-eye": Rt,
  "panel-manual": St,
  paragraph: Tt,
  "parent-back-up": Ut,
  "party-popper": Vt,
  pause: Wt,
  paused: Xt,
  "pencil-edit": Yt,
  phone: Zt,
  "photo-picture": $t,
  pin: om,
  "pin-filled": rm,
  plane: am,
  play: tm,
  plotly: mm,
  "privacy-open": im,
  "privacy-team-private": wm,
  "privacy-team-public": em,
  "privacy-user-private": sm,
  "privacy-user-public": _m,
  python: pm,
  pytorch: bm,
  "pytorch-lightning": lm,
  queue: fm,
  queued: nm,
  "quickstart-code": cm,
  "radio-tower": dm,
  randomize: um,
  "randomize-alt": hm,
  reasoning: gm,
  "receipt-text": km,
  "recent-clock": ym,
  "reddit-social": vm,
  redo: xm,
  regex: zm,
  registries: jm,
  "reload-refresh": qm,
  remove: Im,
  "remove-alt": Am,
  report: Cm,
  reset: Mm,
  "retry-swap": Nm,
  "robot-service-member": Om,
  "rocket-launch": Pm,
  "rowheight-l": Bm,
  "rowheight-m": Dm,
  "rowheight-s": Em,
  "rowheight-xl": Fm,
  "run-set-subset": Gm,
  "run-set-universe": Hm,
  "running-repeat": Jm,
  "sandbox-playground": Km,
  save: Lm,
  "scale-down": Qm,
  "scale-up": Rm,
  scikit: Sm,
  search: Tm,
  "search-results": Um,
  section: Vm,
  "seed-propagate": Wm,
  "select-marquee-tool": Xm,
  "select-move-tool": Ym,
  settings: Zm,
  "settings-parameters": $m,
  "shield-protected": oi,
  "shield-remove": ri,
  "shopping-cart": ai,
  sidebar: ti,
  "sidebar-collapse": mi,
  "sidebar-reveal": ii,
  slack: wi,
  smoothing: ei,
  sort: si,
  "sort-direction": _i,
  spiral: pi,
  split: bi,
  square: li,
  star: fi,
  "star-filled": ni,
  stop: ci,
  stopped: di,
  strikethrough: ui,
  sun: hi,
  "sweep-bayes": gi,
  "sweep-grid": ki,
  "sweep-random-search": yi,
  "sweeps-alt": vi,
  "sweeps-broom": xi,
  "switch-account": zi,
  system: ji,
  "system-chip": qi,
  "system-chip-alt": Ii,
  table: Ai,
  "tablet-responsive": Ci,
  tag: Mi,
  tensorflow: Ni,
  "text-language": Oi,
  "text-language-alt": Pi,
  threads: Bi,
  "thumbs-down": Di,
  "thumbs-up": Ei,
  token: Fi,
  treeview: Gi,
  "triangle-alert": Hi,
  "triangle-down": Ji,
  "triangle-left": Ki,
  "triangle-right": Li,
  "triangle-up": Qi,
  truck: Ri,
  "type-boolean": Si,
  "type-number": Ti,
  "type-number-alt": Ui,
  "type-string-alt": Vi,
  "type-string-quote": Wi,
  "unassigned-01": Xi,
  "unassigned-02": Yi,
  undo: Zi,
  undock: $i,
  "unified-diff": ow,
  "unlocked-unconstrained": rw,
  up: aw,
  "user-author": tw,
  "user-profile-personal": mw,
  "users-team": iw,
  "uuid-identifier": ww,
  "versions-layers": ew,
  "vertex-gcp": sw,
  "video-play": _w,
  "view-alt": pw,
  "view-glasses": bw,
  "visibility-checked": lw,
  "visibility-indeterminate": fw,
  "visibility-unchecked": nw,
  volleyball: cw,
  wandb: dw,
  warning: uw,
  weave: hw,
  webhook: gw,
  "webhook-alt": kw,
  wrap: yw,
  wrench: vw,
  "x-axi-alt": xw,
  "x-axis": zw,
  "x-social": jw,
  "youtube-social": qw,
  "zoom-alt-tool": Iw,
  "zoom-in-tool": Aw,
  "zoom-out-tool": Cw
};
export {
  en as I
};
